import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { clsx } from 'clsx';

import { useIntl } from 'react-intl';

import { sidebarMenu } from '../../config';

import styles from '../sidebar-menu.module.css';

export function SidebarNav() {
	const intl = useIntl();
	const location = useLocation();

	return (
		<nav className={styles.nav}>
			<ul className={styles.navList}>
				{sidebarMenu.map(item => (
					<Fragment key={item.id}>
						<li className={styles.menuTitle}>
							{intl.formatMessage({ id: item.name })}
						</li>
						<ul className={styles.navList}>
							{item.items.map(subItem => {
								const isActive = location.pathname === subItem.path;

								return (
									<li key={subItem.id}>
										<Link
											to={subItem.path}
											aria-current={isActive ? 'page' : undefined}
											className={clsx(
												styles.navItem,
												{ [styles.navItemActive]: isActive },
												styles.navItemContent,
											)}
										>
											<subItem.icon aria-hidden='true' />
											<span>{intl.formatMessage({ id: subItem.label })}</span>
										</Link>
									</li>
								);
							})}
						</ul>
					</Fragment>
				))}
			</ul>
		</nav>
	);
}
